// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"8e9c2c808d6bae6e","487":"d4a1804062a83198","868":"3f93add8453d2cb7","921":"ab03b89bd3721b61"}[chunkId] + ".js";
};